// Action Types
const LOCK_MENU = "user/LOCK_MENU";
const UNLOCK_MENU = "user/UNLOCK_MENU";

// Initial State
const initialState = {
  locked_menu: false,
};

// Action Creators
export const lockMenu = () => ({
  type: LOCK_MENU,
});

export const unlockMenu = () => ({
  type: UNLOCK_MENU,
});

// Reducer
export const playerReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOCK_MENU:
      return {
        locked_menu: true,
      };
    case UNLOCK_MENU:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
